import React from 'react';
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {
  maxValueMonetario,
  minValueMonetario,
  renderFieldCheck,
  renderFieldMonetarioFormulario,
  renderFieldNumeros,
  renderFieldText,
  required,
} from '../../util/inputs';
import Autorizacao from '../../security/Autorizacao';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, getVendedorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import alterarFormaPagamentoPedido from '../../actions/pedido/alterarFormaPagamentoPedido';
import {gerarLinkPagamentoPedidoExistente, gerarQrcodePixCieloEcommercePedidoExistente, gerarQrcodePixSicoobPedidoExistente} from '../../actions/reserva/actionsReserva';
import {usuarioEmpresaHabilitadoCieloEcommerce, usuarioEmpresaHabilitadoSicoob} from '../../actions/usuario/cadastrarUsuariosEmpresaEmLote';
import recuperarFormaPagamentosDesativados from '../../actions/forma-pagamento/recuperarFormaPagamentosDesativados';
import recuperarPagamentosDesativadosUsuario from '../../actions/forma-pagamento/recuperarPagamentosDesativadosUsuario';
import {realParaNumber} from '../../util/numberUtil';
import {tamanhoArquivoUpload} from '../../util/applicationContext';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';
import QRCode from 'qrcode.react';

export class ModalAlterarFormaPagamento extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = { linkGerado: null, copiaEColaGerado: null, copiaEColaGeradoSicoob: null };
  }

  componentDidMount () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.recuperarFormaPagamentosDesativados(this.props.empresaSelecionada.id);
      this.props.recuperarPagamentosDesativadosUsuario(this.props.empresaSelecionada.id);
      this.props.usuarioEmpresaHabilitadoCieloEcommerce(this.props.empresaSelecionada.id);
      this.props.usuarioEmpresaHabilitadoSicoob(this.props.empresaSelecionada.id);
    }
    this.preencherCieloEcommerceDoPedido();
    this.preencherSicoobDoPedido();
  }

  componentDidUpdate (prevProps) {
    if (prevProps.pedido !== this.props.pedido) {
      this.preencherCieloEcommerceDoPedido();
      this.preencherSicoobDoPedido();
    }
  }

  // ao reabrir o modal para um pedido que já tem Cielo E-commerce PIX como
  // forma de pagamento, marca o toggle automaticamente -- sem isso a seção
  // (incluindo o QR Code já gerado) fica escondida atrás de um checkbox
  // desmarcado mesmo com o pagamento já registrado no pedido
  preencherCieloEcommerceDoPedido () {
    const fp = this.formaPagamentoCieloEcommerceDoPedido();
    if (fp) {
      this.props.changeFieldValue('formAlterarFormaPagamento', 'cieloEcommerce', true);
      this.props.changeFieldValue('formAlterarFormaPagamento', 'valorCieloEcommerce',
        fp.valor.toString().replace('.', ','));
    }
  }

  // mesma lógica de preencherCieloEcommerceDoPedido, mas para Sicoob
  preencherSicoobDoPedido () {
    const fp = this.formaPagamentoSicoobDoPedido();
    if (fp) {
      this.props.changeFieldValue('formAlterarFormaPagamento', 'sicoob', true);
      this.props.changeFieldValue('formAlterarFormaPagamento', 'valorSicoob',
        fp.valor.toString().replace('.', ','));
    }
  }

  formaCartaoDisponivel () {
    const desativados = this.props.pagamentosDesativados || [];
    const desativadosUsuario = this.props.pagamentosDesativadosUsuario || [];
    const creditoDesativado = desativados.includes('CARTAO_CREDITO') || desativadosUsuario.includes('CARTAO_CREDITO');
    const debitoDesativado = desativados.includes('CARTAO_DEBITO') || desativadosUsuario.includes('CARTAO_DEBITO');
    return !(creditoDesativado && debitoDesativado);
  }

  formaPixDisponivel () {
    const desativados = this.props.pagamentosDesativados || [];
    const desativadosUsuario = this.props.pagamentosDesativadosUsuario || [];
    return !desativados.includes('PIX') && !desativadosUsuario.includes('PIX');
  }

  formaDinheiroDisponivel () {
    const desativados = this.props.pagamentosDesativados || [];
    const desativadosUsuario = this.props.pagamentosDesativadosUsuario || [];
    return !desativados.includes('DINHEIRO') && !desativadosUsuario.includes('DINHEIRO');
  }

  formaLinkPagamentoDisponivel () {
    const desativados = this.props.pagamentosDesativados || [];
    return !!(this.props.usuariosEmpresa && this.props.usuariosEmpresa.habilitadoPagamentoViaLink)
      && !desativados.includes('LINK_PAGAMENTO');
  }

  formaCieloEcommerceDisponivel () {
    const desativados = this.props.pagamentosDesativados || [];
    return !!(this.props.usuariosEmpresa && this.props.usuariosEmpresa.habilitadoCieloEcommerce)
      && !desativados.includes('CIELO_ECOMMERCE');
  }

  formaSicoobDisponivel () {
    const desativados = this.props.pagamentosDesativados || [];
    return !!(this.props.usuariosEmpresa && this.props.usuariosEmpresa.habilitadoSicoob)
      && !desativados.includes('SICOOB');
  }

  nenhumaFormaDisponivel () {
    return !this.formaCartaoDisponivel() && !this.formaPixDisponivel() && !this.formaDinheiroDisponivel();
  }

  fecharModal () {
    $('#modalAlterarFormaPagamento').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    this.setState({ linkGerado: null, copiaEColaGerado: null });
    this.props.reset('formAlterarFormaPagamento')
  }

  submit (values) {
    const pagamento = [];
    if (values.cartao) {
      pagamento.push({
        tipo: 'Cartão',
        codigoTipo: 'CARTAO',
        base64Comprovante: values.base64Comprovante,
        numeroComprovante: values.numeroComprovante,
        valor: realParaNumber(values.valorCartao.toString()),
        quantidadeParcelas: values.quantidadeParcelas,
        nomeComprovante: values.nomeComprovante,
        urlComprovante: values.urlComprovante
      })
    }

    if (values.dinheiro) {
      pagamento.push({
        tipo: 'Dinheiro',
        codigoTipo: 'DINHEIRO',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: realParaNumber(values.valorDinheiro),
        quantidadeParcelas: 1
      })
    }

    if (values.pix) {
      pagamento.push({
        tipo: 'PIX',
        codigoTipo: 'PIX',
        base64Comprovante: values.base64ComprovantePIX,
        numeroComprovante: values.numeroComprovantePIX,
        valor: realParaNumber(values.valorPIX.toString()),
        quantidadeParcelas: 1,
        nomeComprovante: values.nomeComprovantePIX,
        urlComprovante: values.urlComprovantePIX
      })
    }

    if (values.linkPagamento) {
      pagamento.push({
        tipo: 'Link Pagamento',
        codigoTipo: 'LINK_PAGAMENTO',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: realParaNumber(values.valorLinkPagamento.toString()),
        quantidadeParcelas: 1
      })
    }

    if (values.cieloEcommerce) {
      pagamento.push({
        tipo: 'Cielo E-commerce PIX',
        codigoTipo: 'CIELO_ECOMMERCE',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: realParaNumber(values.valorCieloEcommerce.toString()),
        quantidadeParcelas: 1
      })
    }

    if (values.sicoob) {
      pagamento.push({
        tipo: 'Sicoob PIX',
        codigoTipo: 'SICOOB',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: realParaNumber(values.valorSicoob.toString()),
        quantidadeParcelas: 1
      })
    }

    const alterarFormaPagamento = {
      formasPagamento: pagamento,
      empresaId: this.props.empresaSelecionada.id,
      pedidoId: this.props.pedido.id

    };

    this.props.alterarFormaPagamentoPedido(alterarFormaPagamento)
      .then(() => {
          showSuccessMsg('Forma de pagamento alterada com sucesso');
          this.fecharModal();
          this.props.buscarPedidos();
      })
  }

  handleChange (event) {
    const file = event.target.files[0];
    if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
      return
    }
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return
    }
    this.converterParaBase64(file, 'CARTAO')
  }

  handleChangePix (event) {
    const file = event.target.files[0];
    if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
      return
    }
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return
    }
    this.converterParaBase64(file, 'PIX')
  }

  converterParaBase64 (file, formaPagamento) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      if(formaPagamento === 'PIX') {
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'base64ComprovantePIX', reader.result);
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'nomeComprovantePIX', file.name);
      } else {
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'base64Comprovante', reader.result);
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'nomeComprovante', file.name);
      }
    }.bind(this);
  }

  limparFormulario () {
    this.props.reset('formAlterarFormaPagamento');
    this.removerArquivo();
  }

  exibirAnexar () {
    const perfilAnexo = [PERFIL_ADMIN,
      getGestorEmpresa(this.props.empresaSelecionada.id),
      getAdminEmpresa(this.props.empresaSelecionada.id),
      getOperadorEmpresa(this.props.empresaSelecionada.id),
      getVendedorEmpresa(this.props.empresaSelecionada.id)];

    if (this.props.base64Comprovante || this.props.urlComprovante) {
      return (
        <Autorizacao perfisPermitidos={perfilAnexo}>
          <div className="vx-modal-attach">
            <div className="vx-modal-attach-file">
              <span className="material-icons">description</span>
              <span style={{flex: 1, minWidth: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{this.props.nomeComprovante}</span>
              {this.props.urlComprovante && (
                <button type="button" className="vx-modal-attach-remove" style={{borderColor:'#28a745',color:'#28a745'}}
                        title="Baixar" onClick={() => window.open(this.props.urlComprovante, '_blank')}>
                  <span className="material-icons">download</span>
                  Baixar
                </button>
              )}
              <button type="button" className="vx-modal-attach-remove"
                      title="Remover" onClick={() => this.removerArquivo('CARTAO')}>
                <span className="material-icons">delete</span>
                Remover
              </button>
            </div>
          </div>
        </Autorizacao>)
    }
    return (
      <Autorizacao perfisPermitidos={perfilAnexo}>
        <div className="vx-modal-attach">
          <label className="vx-modal-attach-btn" htmlFor='input-file'>
            <span className="material-icons">attach_file</span>
            Anexar comprovante
          </label>
          <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChange.bind(this)} style={{display: 'none'}}/>
          <div className="vx-modal-attach-hint">* JPG, PNG ou PDF — máx. 20 MB</div>
        </div>
      </Autorizacao>)
  }

  exibirAnexarPix () {
    const perfilAnexo = [PERFIL_ADMIN,
      getGestorEmpresa(this.props.empresaSelecionada.id),
      getAdminEmpresa(this.props.empresaSelecionada.id),
      getOperadorEmpresa(this.props.empresaSelecionada.id),
      getVendedorEmpresa(this.props.empresaSelecionada.id)];

    if (this.props.base64ComprovantePIX || this.props.urlComprovantePIX) {
      return (
        <Autorizacao perfisPermitidos={perfilAnexo}>
          <div className="vx-modal-attach">
            <div className="vx-modal-attach-file">
              <span className="material-icons">description</span>
              <span style={{flex: 1, minWidth: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{this.props.nomeComprovantePIX}</span>
              {this.props.urlComprovantePIX && (
                <button type="button" className="vx-modal-attach-remove" style={{borderColor:'#28a745',color:'#28a745'}}
                        title="Baixar" onClick={() => window.open(this.props.urlComprovantePIX, '_blank')}>                  
                  Baixar
                </button>
              )}
              <button type="button" className="vx-modal-attach-remove"
                      title="Remover" onClick={() => this.removerArquivo('PIX')}>
                <span className="material-icons">delete</span>
                Remover
              </button>
            </div>
          </div>
        </Autorizacao>)
    }
    return (
      <Autorizacao perfisPermitidos={perfilAnexo}>
        <div className="vx-modal-attach">
          <label className="vx-modal-attach-btn" htmlFor='input-file-pix'>
            <span className="material-icons">attach_file</span>
            Anexar comprovante PIX
          </label>
          <input id='input-file-pix' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChangePix.bind(this)} style={{display: 'none'}}/>
          <div className="vx-modal-attach-hint">* JPG, PNG ou PDF — máx. 20 MB</div>
        </div>
      </Autorizacao>)
  }

  exibirBaixarComprovante () { return null; }
  exibirBaixarComprovantePix () { return null; }
  exibirRemoverComprovante () { return null; }

  removerArquivo (formaPagamento) {
    if(formaPagamento === 'PIX') {
      this.props.changeFieldValue('formAlterarFormaPagamento',
      'base64ComprovantePIX', null);
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'nomeComprovantePIX', '');
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'urlComprovantePIX', null);
    } else {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'base64Comprovante', null);
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'nomeComprovante', '');
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'urlComprovante', null);
    }
  }

  handleCheckDinheiro () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'dinheiro', !this.props.dinheiro);
  }

  handleCkeckCartao () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'cartao', !this.props.cartao);
  }

  handleCkeckPix () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'pix', !this.props.pix);
  }

  handleCheckLinkPagamento () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'linkPagamento', !this.props.linkPagamento);
  }

  handleCheckCieloEcommerce () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'cieloEcommerce', !this.props.cieloEcommerce);
  }

  handleCheckSicoob () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'sicoob', !this.props.sicoob);
  }

  gerarLink () {
    this.props.gerarLinkPagamentoPedidoExistente(this.props.pedido.id, this.props.empresaSelecionada.id)
      .then(resp => {
        const { shortUrl } = resp.payload.data;
        this.setState({ linkGerado: shortUrl });
        showSuccessMsg('Link de pagamento gerado com sucesso!');
        this.props.buscarPedidos();
      })
      .catch(() => showErrorMsg('Erro ao gerar link de pagamento.'));
  }

  linkAtualDoPedido () {
    if (!this.props.pedido || !this.props.pedido.formasPagamentoDto) return null;
    const fp = this.props.pedido.formasPagamentoDto.find(f => f.tipo === 'Link Pagamento');
    return fp ? fp.linkPagamento : null;
  }

  formaPagamentoCieloEcommerceDoPedido () {
    if (!this.props.pedido || !this.props.pedido.formasPagamentoDto) return null;
    return this.props.pedido.formasPagamentoDto.find(f => f.tipo === 'Cielo E-commerce PIX');
  }

  copiaEColaAtualDoPedido () {
    const fp = this.formaPagamentoCieloEcommerceDoPedido();
    return fp ? fp.linkPagamento : null;
  }

  // janela de validade da Cielo (30 minutos) a partir de dataGeracaoPix --
  // não existe nenhum dado de expiração retornado pela Cielo nem em outro
  // lugar do domínio, então o cálculo é feito aqui a partir do timestamp
  // salvo em FormaPagamento.dataGeracaoPix (ver plano, seção 3.4)
  cieloEcommercePixAtivo () {
    const fp = this.formaPagamentoCieloEcommerceDoPedido();
    if (!fp || !fp.linkPagamento || !fp.dataGeracaoPix) return false;
    const geradoEm = new Date(fp.dataGeracaoPix).getTime();
    return (Date.now() - geradoEm) < 30 * 60 * 1000;
  }

  gerarQrCodeCieloEcommerce () {
    this.props.gerarQrcodePixCieloEcommercePedidoExistente(this.props.pedido.id, this.props.empresaSelecionada.id)
      .then(resp => {
        const { copiaECola } = resp.payload.data;
        this.setState({ copiaEColaGerado: copiaECola });
        showSuccessMsg('QR Code PIX gerado com sucesso!');
        this.props.buscarPedidos();
      })
      .catch(() => showErrorMsg('Erro ao gerar QR Code PIX.'));
  }

  // reabre o QR Code já gerado anteriormente, sem chamar o backend/Cielo de
  // novo -- só disponível enquanto cieloEcommercePixAtivo() for true
  abrirQrCodeCieloEcommerce () {
    this.setState({ copiaEColaGerado: this.copiaEColaAtualDoPedido() });
  }

  formaPagamentoSicoobDoPedido () {
    if (!this.props.pedido || !this.props.pedido.formasPagamentoDto) return null;
    return this.props.pedido.formasPagamentoDto.find(f => f.tipo === 'Sicoob PIX');
  }

  copiaEColaAtualDoPedidoSicoob () {
    const fp = this.formaPagamentoSicoobDoPedido();
    return fp ? fp.linkPagamento : null;
  }

  // mesma janela de validade de 30 minutos usada para Cielo E-commerce (não
  // existe dado de expiração retornado pela Sicoob)
  sicoobPixAtivo () {
    const fp = this.formaPagamentoSicoobDoPedido();
    if (!fp || !fp.linkPagamento || !fp.dataGeracaoPix) return false;
    const geradoEm = new Date(fp.dataGeracaoPix).getTime();
    return (Date.now() - geradoEm) < 30 * 60 * 1000;
  }

  gerarQrCodeSicoob () {
    this.props.gerarQrcodePixSicoobPedidoExistente(this.props.pedido.id, this.props.empresaSelecionada.id)
      .then(resp => {
        const { copiaECola } = resp.payload.data;
        this.setState({ copiaEColaGeradoSicoob: copiaECola });
        showSuccessMsg('QR Code PIX gerado com sucesso!');
        this.props.buscarPedidos();
      })
      .catch(() => showErrorMsg('Erro ao gerar QR Code PIX.'));
  }

  abrirQrCodeSicoob () {
    this.setState({ copiaEColaGeradoSicoob: this.copiaEColaAtualDoPedidoSicoob() });
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;

    return (
      <div className="modal fade show" role="dialog"
           id="modalAlterarFormaPagamento" aria-labelledby="modalAlterarFormaPagamento" aria-hidden="true"
           data-backdrop="static">
        <div className="modal-dialog modal-info modal-md modal-dialog-centered">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">payment</span>
                Alterar Forma de Pagamento
                {this.props.pedido
                  ? <span style={{fontWeight: 400, fontSize: '13px', opacity: .7}}> — Pedido #{this.props.pedido.id}</span>
                  : ''}
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal"
                      id="btnFecharModalAlterarFormaPagamento"
                      onClick={() => this.limparFormulario()} aria-label="Fechar">
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit)}>
              <div className="vx-modal-body">

                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <span className="material-icons">payments</span>
                    Formas de pagamento
                  </div>

                  {this.formaCartaoDisponivel() && (
                    <div className={`vx-pay-toggle${this.props.cartao ? ' vx-pay-toggle--active' : ''}`}
                         onClick={() => this.handleCkeckCartao()}>
                      <span className="material-icons">credit_card</span>
                      <span className="vx-pay-toggle-label">Cartão</span>
                      <Field name="cartao" type="checkbox" component={renderFieldCheck} label=""
                             css="form-check-input" readOnly={false} onChange={() => {}}/>
                    </div>
                  )}
                  {this.props.cartao && (
                    <div className="vx-pay-fields">
                      {this.exibirAnexar()}
                      <div className="form-group mt-2">
                        <Field name="numeroComprovante" type="text" component={renderFieldText}
                               css="form-control" label="Número comprovante:"/>
                      </div>
                      <div className="form-group">
                        <Field name="quantidadeParcelas" type="text" component={renderFieldNumeros}
                               label="Quantidade de parcelas:" valor={this.props.quantidadeParcelas}
                               css="form-control col-md-4" readOnly={false}/>
                      </div>
                      <div className="form-group">
                        <Field name="valorCartao" type="text"
                               validate={[required, maxValueMonetario, minValueMonetario]}
                               component={renderFieldMonetarioFormulario}
                               css="form-control col-md-4" label="Valor em cartão"/>
                      </div>
                    </div>
                  )}

                  {this.formaPixDisponivel() && (
                    <div className={`vx-pay-toggle${this.props.pix ? ' vx-pay-toggle--active' : ''}`}
                         onClick={() => this.handleCkeckPix()}>
                      <span className="material-icons">pix</span>
                      <span className="vx-pay-toggle-label">PIX</span>
                      <Field name="pix" type="checkbox" component={renderFieldCheck} label=""
                             css="form-check-input" readOnly={false} onChange={() => {}}/>
                    </div>
                  )}
                  {this.props.pix && (
                    <div className="vx-pay-fields">
                      {this.exibirAnexarPix()}
                      <div className="form-group mt-2">
                        <Field name="numeroComprovantePIX" type="text" component={renderFieldText}
                               css="form-control" label="Número comprovante PIX:"/>
                      </div>
                      <div className="form-group">
                        <Field name="valorPIX" type="text"
                               validate={[required, maxValueMonetario, minValueMonetario]}
                               component={renderFieldMonetarioFormulario}
                               css="form-control col-md-4" label="Valor em PIX"/>
                      </div>
                    </div>
                  )}

                  {this.formaDinheiroDisponivel() && (
                    <div className={`vx-pay-toggle${this.props.dinheiro ? ' vx-pay-toggle--active' : ''}`}
                         onClick={() => this.handleCheckDinheiro()}>
                      <span className="material-icons">money</span>
                      <span className="vx-pay-toggle-label">Dinheiro</span>
                      <Field name="dinheiro" type="checkbox" component={renderFieldCheck} label=""
                             css="form-check-input" readOnly={false} onChange={() => {}}/>
                    </div>
                  )}
                  {this.props.dinheiro && (
                    <div className="vx-pay-fields">
                      <div className="form-group">
                        <Field name="valorDinheiro" type="text"
                               validate={[required, maxValueMonetario, minValueMonetario]}
                               component={renderFieldMonetarioFormulario}
                               css="form-control col-md-4" label="Valor em dinheiro"/>
                      </div>
                    </div>
                  )}

                  {this.nenhumaFormaDisponivel() && (
                    <div className="alert alert-warning" style={{marginTop: 10}}>
                      Nenhuma forma de pagamento disponível para alteração. Fale com o administrador da empresa.
                    </div>
                  )}

                  {this.formaLinkPagamentoDisponivel() && (
                    <React.Fragment>
                      <div className={`vx-pay-toggle${this.props.linkPagamento ? ' vx-pay-toggle--active' : ''}`}
                           onClick={() => this.handleCheckLinkPagamento()}>
                        <span className="material-icons">link</span>
                        <span className="vx-pay-toggle-label">Link de Pagamento</span>
                        <Field name="linkPagamento" type="checkbox" component={renderFieldCheck} label=""
                               css="form-check-input" readOnly={false} onChange={() => {}}/>
                      </div>
                      {this.props.linkPagamento && (
                        <div className="vx-pay-fields">
                          <div className="form-group">
                            <Field name="valorLinkPagamento" type="text"
                                   validate={[required, maxValueMonetario, minValueMonetario]}
                                   component={renderFieldMonetarioFormulario}
                                   css="form-control col-md-4" label="Valor em link de pagamento"/>
                          </div>
                          <button type="button" className="vx-modal-btn-confirmar" style={{marginBottom: 10}}
                                  onClick={() => this.gerarLink()}>
                            <span className="material-icons" style={{fontSize: 16}}>link</span>
                            Gerar Link
                          </button>
                          {(this.state.linkGerado || this.linkAtualDoPedido()) && (
                            <div className="vx-pay-link-box">
                              <div style={{fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: 4}}>Link gerado</div>
                              <div className="vx-pay-link-url">
                                <a href={this.state.linkGerado || this.linkAtualDoPedido()} target="_blank"
                                   rel="noopener noreferrer" style={{flex: 1, color: '#FF6A00', fontSize: 12}}>
                                  {this.state.linkGerado || this.linkAtualDoPedido()}
                                </a>
                                <button type="button" className="vx-pay-link-copy" title="Copiar link"
                                        onClick={() => {
                                          navigator.clipboard.writeText(this.state.linkGerado || this.linkAtualDoPedido());
                                          showSuccessMsg('Link copiado!');
                                        }}>
                                  <span className="material-icons">content_copy</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  )}

                  {this.formaCieloEcommerceDisponivel() && (
                    <React.Fragment>
                      <div className={`vx-pay-toggle${this.props.cieloEcommerce ? ' vx-pay-toggle--active' : ''}`}
                           onClick={() => this.handleCheckCieloEcommerce()}>
                        <span className="material-icons">pix</span>
                        <span className="vx-pay-toggle-label">Cielo E-commerce PIX</span>
                        <Field name="cieloEcommerce" type="checkbox" component={renderFieldCheck} label=""
                               css="form-check-input" readOnly={false} onChange={() => {}}/>
                      </div>
                      {this.props.cieloEcommerce && (
                        <div className="vx-pay-fields">
                          <div className="form-group">
                            <Field name="valorCieloEcommerce" type="text"
                                   validate={[required, maxValueMonetario, minValueMonetario]}
                                   component={renderFieldMonetarioFormulario}
                                   css="form-control col-md-4" label="Valor em Cielo E-commerce PIX"/>
                          </div>
                          {this.cieloEcommercePixAtivo() ? (
                            <button type="button" className="vx-modal-btn-confirmar" style={{marginBottom: 10}}
                                    onClick={() => this.abrirQrCodeCieloEcommerce()}>
                              <span className="material-icons" style={{fontSize: 16}}>pix</span>
                              Abrir QR Code PIX
                            </button>
                          ) : (
                            <button type="button" className="vx-modal-btn-confirmar" style={{marginBottom: 10}}
                                    disabled={!!this.state.copiaEColaGerado}
                                    onClick={() => this.gerarQrCodeCieloEcommerce()}>
                              <span className="material-icons" style={{fontSize: 16}}>pix</span>
                              Gerar QR Code PIX
                            </button>
                          )}
                          {(this.state.copiaEColaGerado || this.copiaEColaAtualDoPedido()) && (
                            <div className="vx-pay-link-box">
                              <div style={{fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: 4}}>QR Code PIX gerado</div>
                              <div style={{textAlign: 'center', marginBottom: 8}}>
                                <QRCode value={this.state.copiaEColaGerado || this.copiaEColaAtualDoPedido()} size={140}/>
                              </div>
                              <div className="vx-pay-link-url">
                                <span style={{flex: 1, color: '#FF6A00', fontSize: 12, wordBreak: 'break-all'}}>
                                  {this.state.copiaEColaGerado || this.copiaEColaAtualDoPedido()}
                                </span>
                                <button type="button" className="vx-pay-link-copy" title="Copiar código PIX"
                                        onClick={() => {
                                          navigator.clipboard.writeText(this.state.copiaEColaGerado || this.copiaEColaAtualDoPedido());
                                          showSuccessMsg('Código PIX copiado!');
                                        }}>
                                  <span className="material-icons">content_copy</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  )}

                  {this.formaSicoobDisponivel() && (
                    <React.Fragment>
                      <div className={`vx-pay-toggle${this.props.sicoob ? ' vx-pay-toggle--active' : ''}`}
                           onClick={() => this.handleCheckSicoob()}>
                        <span className="material-icons">pix</span>
                        <span className="vx-pay-toggle-label">Sicoob PIX</span>
                        <Field name="sicoob" type="checkbox" component={renderFieldCheck} label=""
                               css="form-check-input" readOnly={false} onChange={() => {}}/>
                      </div>
                      {this.props.sicoob && (
                        <div className="vx-pay-fields">
                          <div className="form-group">
                            <Field name="valorSicoob" type="text"
                                   validate={[required, maxValueMonetario, minValueMonetario]}
                                   component={renderFieldMonetarioFormulario}
                                   css="form-control col-md-4" label="Valor em Sicoob PIX"/>
                          </div>
                          {this.sicoobPixAtivo() ? (
                            <button type="button" className="vx-modal-btn-confirmar" style={{marginBottom: 10}}
                                    onClick={() => this.abrirQrCodeSicoob()}>
                              <span className="material-icons" style={{fontSize: 16}}>pix</span>
                              Abrir QR Code PIX
                            </button>
                          ) : (
                            <button type="button" className="vx-modal-btn-confirmar" style={{marginBottom: 10}}
                                    disabled={!!this.state.copiaEColaGeradoSicoob}
                                    onClick={() => this.gerarQrCodeSicoob()}>
                              <span className="material-icons" style={{fontSize: 16}}>pix</span>
                              Gerar QR Code PIX
                            </button>
                          )}
                          {(this.state.copiaEColaGeradoSicoob || this.copiaEColaAtualDoPedidoSicoob()) && (
                            <div className="vx-pay-link-box">
                              <div style={{fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: 4}}>QR Code PIX gerado</div>
                              <div style={{textAlign: 'center', marginBottom: 8}}>
                                <QRCode value={this.state.copiaEColaGeradoSicoob || this.copiaEColaAtualDoPedidoSicoob()} size={140}/>
                              </div>
                              <div className="vx-pay-link-url">
                                <span style={{flex: 1, color: '#FF6A00', fontSize: 12, wordBreak: 'break-all'}}>
                                  {this.state.copiaEColaGeradoSicoob || this.copiaEColaAtualDoPedidoSicoob()}
                                </span>
                                <button type="button" className="vx-pay-link-copy" title="Copiar código PIX"
                                        onClick={() => {
                                          navigator.clipboard.writeText(this.state.copiaEColaGeradoSicoob || this.copiaEColaAtualDoPedidoSicoob());
                                          showSuccessMsg('Código PIX copiado!');
                                        }}>
                                  <span className="material-icons">content_copy</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </div>

                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <span className="material-icons">receipt</span>
                    Resumo
                  </div>
                  <Field name="valorTotal" type="text" readOnly={true} component={renderFieldMonetarioFormulario}
                         css="form-control col-md-5" label="Valor total do pedido"/>
                </div>

              </div>

              <div className="vx-modal-footer">
                <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                        onClick={() => this.limparFormulario()}>
                  Cancelar
                </button>
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                  getAdminEmpresa(this.props.empresaSelecionada.id),
                  getGestorEmpresa(this.props.empresaSelecionada.id),
                  getOperadorEmpresa(this.props.empresaSelecionada.id),
                  getVendedorEmpresa(this.props.empresaSelecionada.id)
                ]}>
                  <button type="submit" className="vx-modal-btn-confirmar"
                          id="btn-confirmar-acesso-autos"
                          disabled={invalid || submitting || pristine || this.nenhumaFormaDisponivel()}>
                    <span className="material-icons" style={{fontSize: 16}}>check_circle</span>
                    Salvar
                  </button>
                </Autorizacao>
              </div>
            </form>

          </div>
        </div>
      </div>
    )
  }
}

const seletor = formValueSelector('formAlterarFormaPagamento');

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    usuariosEmpresa: state.usuariosEmpresa,
    pedido: state.pedido,
    itemFechamento: state.itemFechamento,
    pagamentosDesativados: state.pagamentosDesativados.pagamentosDesativados,
    pagamentosDesativadosUsuario: state.pagamentosDesativadosUsuario.pagamentosDesativadosUsuario,
    nomeComprovante: seletor(state, 'nomeComprovante'),
    urlComprovante: seletor(state, 'urlComprovante'),
    base64Comprovante: seletor(state, 'base64Comprovante'),
    quantidadeParcelas: seletor(state, 'quantidadeParcelas'),
    nomeComprovantePIX: seletor(state, 'nomeComprovantePIX'),
    urlComprovantePIX: seletor(state, 'urlComprovantePIX'),
    base64ComprovantePIX: seletor(state, 'base64ComprovantePIX'),
    dinheiro: seletor(state, 'dinheiro'),
    cartao: seletor(state, 'cartao'),
    pix: seletor(state, 'pix'),
    linkPagamento: seletor(state, 'linkPagamento'),
    cieloEcommerce: seletor(state, 'cieloEcommerce'),
    sicoob: seletor(state, 'sicoob')
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    alterarFormaPagamentoPedido,
    gerarLinkPagamentoPedidoExistente,
    gerarQrcodePixCieloEcommercePedidoExistente,
    gerarQrcodePixSicoobPedidoExistente,
    usuarioEmpresaHabilitadoCieloEcommerce,
    usuarioEmpresaHabilitadoSicoob,
    recuperarFormaPagamentosDesativados,
    recuperarPagamentosDesativadosUsuario
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formAlterarFormaPagamento',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalAlterarFormaPagamento));
